import { AlertTriangle } from "lucide-react";

import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import useTranslations from "@/shared/lang/useTranslations";

import type { CardWalletIneligibility } from "../types/cardWallets.types";

const MESSAGE_KEYS = {
  no_program: "ineligible_no_program",
  not_crypto: "ineligible_bloque",
  not_usd: "ineligible_currency",
  not_card_wallet: "ineligible_wallet_type",
} as const;

export interface CardWalletEligibilityNoticeProps {
  reason: CardWalletIneligibility;
  className?: string;
}

/**
 * Why this organization's balance cannot be moved from here.
 *
 * Always provider-neutral: a Bloque organization reads as "Coloca Cards", never as the vendor's name
 * (CLAUDE.md rule 12), and the backend's own sentence — which does name it — is never rendered.
 */
export function CardWalletEligibilityNotice({ reason, className }: CardWalletEligibilityNoticeProps) {
  const { t } = useTranslations("cardWallets");
  return (
    <ColocaAlert
      variant="warning"
      icon={AlertTriangle}
      text={t(MESSAGE_KEYS[reason])}
      className={className}
    />
  );
}
